import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, VStack, Text } from '@chakra-ui/react';
import { useAuthState } from 'react-firebase-hooks/auth';

import { auth, login, logout, sendWarehouseLowStockEmail } from '../api';

// TBD devo creare questi utenti in tutti i db demo (canterano e darsena)
// non lo sto facendo ora perche' sono a ridosso del carnevale
const accounts = [
  { label: 'Admin', email: 'giggioz@popular.com' },
  { label: 'Cassa', email: 'cassa1@popular.com' },
  { label: 'Magazziniere', email: 'warehouse1@popular.com' },
  { label: 'Operatore', email: 'operatore1@popular.com' },
  { label: 'Promoter', email: 'promoter1@popular.com' },
];

const QUICK_LOGIN_PASSWORD = 'xxxxxx';

const QuickLogin = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentAction, setCurrentAction] = useState('');
  const [testEmailLoading, setTestEmailLoading] = useState(false);
  const [testEmailResult, setTestEmailResult] = useState('');

  const handleLogin = async (email, label) => {
    setError('');
    setIsLoading(true);
    setCurrentAction(label);
    const result = await login(email, QUICK_LOGIN_PASSWORD);
    if (!result.success) {
      setError(result.message || 'Errore di login');
    }
    setIsLoading(false);
    setCurrentAction('');
  };

  const handleLogout = async () => {
    setError('');
    setIsLoading(true);
    setCurrentAction('Logout');
    await logout();
    setIsLoading(false);
    setCurrentAction('');
    navigate('/menu');
  };

  const handleTestLowStockEmail = async () => {
    setTestEmailResult('');
    setTestEmailLoading(true);
    try {
      const result = await sendWarehouseLowStockEmail(
        'Prodotto Test',
        5,
        10,
        'giggioz@gmail.com'
      );
      if (result.success) {
        setTestEmailResult('Email inviata con successo!');
      } else {
        setTestEmailResult(`Errore: ${result.error || 'Errore sconosciuto'}`);
      }
    } catch (err) {
      setTestEmailResult(`Errore: ${err.message}`);
    } finally {
      setTestEmailLoading(false);
    }
  };

  const isLoggedIn = !!user;
  const role = user?.displayName || 'anonimo';

  return (
    <Box position='fixed' top={4} right={4} zIndex={2000}>
      <Box
        bg='rgba(0,0,0,0.8)'
        color='white'
        p={3}
        borderRadius='md'
        borderWidth='1px'
        borderColor='gold'
        boxShadow='lg'
        maxW='220px'
      >
        <Text fontSize='sm' fontWeight='bold' mb={2}>
          Quick Login
        </Text>
        <Text fontSize='xs' mb={2}>
          Utente: {isLoggedIn ? user.email : 'non loggato'}
        </Text>
        <Text fontSize='xs' mb={3}>
          Ruolo: {role}
        </Text>
        <VStack align='stretch' spacing={1} mb={2}>
          <Button
            size='xs'
            variant='ghost'
            colorScheme='yellow'
            onClick={() => navigate('/menu')}
          >
            Vai al Menu
          </Button>
          <Button
            size='xs'
            variant='ghost'
            colorScheme='yellow'
            onClick={() => navigate('/dashboard')}
          >
            Vai alla Dashboard
          </Button>
          {isLoggedIn && role === 'admin' && (
            <Button
              size='xs'
              variant='ghost'
              colorScheme='yellow'
              onClick={() => navigate('/dashboard/users')}
            >
              Show Users
            </Button>
          )}
        </VStack>
        <VStack align='stretch' spacing={1}>
          {accounts.map((account) => (
            <Button
              key={account.email}
              size='xs'
              colorScheme='teal'
              color='gold'
              variant='solid'
              onClick={() => handleLogin(account.email, account.label)}
              isLoading={isLoading && currentAction === account.label}
              loadingText={account.label}
            >
              {account.label}
            </Button>
          ))}
          <Button
            size='xs'
            colorScheme='red'
            variant='outline'
            onClick={handleLogout}
            isDisabled={!isLoggedIn}
            isLoading={isLoading && currentAction === 'Logout'}
            loadingText='Logout'
          >
            Logout
          </Button>
          <Button
            size='xs'
            colorScheme='orange'
            variant='outline'
            onClick={handleTestLowStockEmail}
            isLoading={testEmailLoading}
            loadingText='Invio...'
          >
            Invia Mail Soglia Minima
          </Button>
        </VStack>
        {error && (
          <Text mt={2} fontSize='xs' color='tomato'>
            {error}
          </Text>
        )}
        {testEmailResult && (
          <Text mt={2} fontSize='xs' color={testEmailResult.includes('successo') ? 'green.300' : 'tomato'}>
            {testEmailResult}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default QuickLogin;

